
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/takeback",
      function () {
        return require("private-next-pages/takeback.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/takeback"])
      });
    }
  